var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9992 0C22.4788 14.2079 0.0195312 11 0.0195312 11V49.5C0.0195312 72.1875 35.9992 88 35.9992 88C35.9992 88 71.9788 72.1875 71.9788 49.5V11C71.9788 11 49.5195 14.2079 35.9992 0Z",
    fill: "#FFC7C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9987 12.666C26.3696 22.7846 10.377 20.4994 10.377 20.4994V47.9169C10.377 64.0731 35.9987 75.3358 35.9987 75.3358C35.9987 75.3358 61.6218 64.0745 61.6218 47.9183V20.5008C61.6218 20.5008 45.6278 22.7846 35.9987 12.666Z",
    fill: "#FF5A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.356 55.3586C34.3454 56.7917 32.3264 57.0562 30.9807 55.9318L22.3011 48.6793C21.1359 47.7057 20.9804 45.9719 21.9537 44.8064C22.9274 43.6405 24.662 43.485 25.8276 44.459L32.4248 49.9718L45.1062 31.9905C45.9812 30.7497 47.6962 30.453 48.9372 31.3277C50.1787 32.2027 50.4756 33.9185 49.6002 35.1598L35.356 55.3586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.9a814482abab8cfe0d419917c641c8d6.svg";
export { ForwardRef as ReactComponent };